import styled from "styled-components";

export const Description = styled.div`
    ol {
        padding-block: var(--spacing-4) var(--spacing-2);
        padding-inline: 0;
        counter-reset: steps;
        list-style-type: none;
        li {
            display: flex;
            gap: var(--spacing-1);
            align-items: center;
            margin-bottom: var(--spacing-2);
            &::before {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 3.2rem;
                height: 3.2rem;
                font-family: var(--font-book);
                color: var(--color-primary-white);
                content: counters(steps, "");
                background: var(--color-primary-black);
                border-radius: 50%;
                counter-increment: steps;
            }
        }
    }
`;
export const Footer = styled.footer`
    display: flex;
    justify-content: flex-end;
    padding-top: var(--spacing-5);
`;
